import { render, staticRenderFns } from "./todoItem.vue?vue&type=template&id=10505ed2&"
import script from "./todoItem.vue?vue&type=script&lang=js&"
export * from "./todoItem.vue?vue&type=script&lang=js&"
import style0 from "./todoItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports